module.exports = __webpack_public_path__ + "static/img/animals11.df923111.png";